var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.6231 17.5074L23.4105 18.1436C24.6968 19.1829 24.8592 21.0798 23.7684 22.3229L23.6591 22.4475C22.8774 23.3383 22.6688 24.6542 23.4497 25.5447C24.1966 26.3965 25.1989 27.1459 26.6549 27.9623C27.8031 28.606 29.2387 28.3006 30.1065 27.3116L30.1825 27.2249C31.2171 26.0459 33.0011 25.8929 34.221 26.8786L34.9517 27.469C35.9998 28.3159 36.3646 29.794 35.6112 30.9107C34.9002 31.9645 34.1071 32.7891 33.171 33.4631C32.5739 33.8929 31.8046 33.9885 31.0937 33.7976C24.1438 31.9313 19.9394 28.5405 16.9232 22.2601C16.6605 21.7132 16.5745 21.0845 16.7875 20.5162C17.2373 19.316 18.0786 18.3053 19.3789 17.3382C20.3489 16.6167 21.6835 16.7482 22.6231 17.5074Z",
    stroke: "#CA1211",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.3032 27.5996L35.1173 31.4894",
    stroke: "#CA1211",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0706 18.5234L23.8846 22.4133",
    stroke: "#CA1211",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobile);
export default __webpack_public_path__ + "static/media/mobile.c2732b51635bfdb813d533cc2c466f25.svg";
export { ForwardRef as ReactComponent };